export const config = {
  title: 'Tag to Job',
  okText: 'Tag',
  width: 480,
  disabledUntilFilled: true,
  fields: [
    {
      name: 'jobId',
      label: 'Job Title / ID',
      type: 'search-select',
      required: true,
      placeholder: 'Minimum 3 characters',
      searchFetchKey: 'tagToJobJobList',
    },
    {
      name: 'hiringStage',
      label: 'Hiring stage',
      type: 'select',
      required: true,
      defaultOptions: [
        { label: 'Shortlisted', value: 'Shortlisted' },
        { label: 'Pipeline', value: 'Pipeline' },
      ],
    },
  ],
};
